<template>
  <ModalWithBackdrop
    title="Deseja cancelar o compromisso?"
    :label="confirmLabel"
    :busy="loading"
    v-bind="{ ...$attrs }"
    className="cancelMeeting"
    @secondaryaction="resetHard"
    @action="resolveConfirm"
    @closeclick="resetHard"
  >
    <p class="cancelMeeting__label">Informe o motivo do cancelamento</p>
    <textarea
      v-model="reason"
      maxlength="254"
      class="cancelMeeting__reason"
      placeholder="Digite aqui"
    />
    <p class="cancelMeeting__helpText">*Campo obrigatório</p>
  </ModalWithBackdrop>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ModalWithBackdrop from '@/components/ModalWithBackdrop';
import wait from '@/utils/wait';

export default {
  name: 'CancelMeeting',

  components: { ModalWithBackdrop },

  data: () => ({
    loading: false,
    reason: null,
  }),

  computed: {
    ...mapGetters('dashboard', ['currWorkspace']),
    confirmLabel() {
      return this.loading ? 'Confirmando' : 'Confirmar';
    },
  },

  methods: {
    ...mapActions('dashboard', ['closeModals']),
    ...mapActions('meeting', ['cancelMeeting']),

    reset() {
      Object.assign(this, { reason: null });
    },

    async resetHard() {
      this.closeModals();

      await wait(400);

      this.reset();
    },

    async resolveConfirm() {
      const { reason } = this;
      this.loading = true;

      try {
        await this.cancelMeeting(reason);
        this.resetHard();
      } catch (err) {}

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
